import * as React from "react";
import { Alert, Box } from "@mui/material";
import PlatformDatesAccordion from "../../../../components/shared/platformsDatesAccordion";
import { useGetCclEventByEventKeyQuery } from "../../../../services/cclTokenedSessionApi";

interface MyAccessPlatformDatesAccordionProps {
    sessionKey: string | undefined;
}

const MyAccessPlatformDatesAccordion: React.FC<MyAccessPlatformDatesAccordionProps> = (props) => {
    const { data, isError } = useGetCclEventByEventKeyQuery(props.sessionKey ?? "", {
        skip: props.sessionKey === undefined || props.sessionKey === "",
    });

    if (isError) {
        return <Alert severity="error">Error: Session data not found</Alert>;
    }

    if (data !== undefined) {
        return (
            <Box sx={{ marginBottom: 4 }}>
                <PlatformDatesAccordion sessionDetails={data} readonly={true} fromMyAccess={true} />
            </Box>
        );
    }

    return <></>;
};

export default MyAccessPlatformDatesAccordion;
